export enum ApplicationModuleTypes {
  FIRST = "first",
  SECOND = "second",
  THIRD = "third",
}
